const config = {
  mediaQuery: {
    sp: 'only screen and (max-width: 767px)'
  },
  rss: '/rss.php'
}

export default config
